import { Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import {
  GET_MIGRANTS_GROUPS_CATEGORIES,
  GET_MIGRANTS_GROUPS_CATEGORIES_SUBS,
} from '../../../../graphql/Catalog/Migrants/migrantsProcess'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import MigrantsProcessForms from './MigrantsProcessForms'
import ModalGroupsCategoriesSubs from './ModalGroupsCategoriesSubs'
import ModalContent from '../../../Global/ModalContent'
import Loader from '../../../Global/Spinner'

const MigrantsProcess = () => {
  //------------ Hooks ------------
  const refModalStatus = useRef(null)
  const [modal, setModal] = useState({
    modalId: false,
    size: 'extra',
    title: '',
    content: null,
  })
  const [processController, setProcessController] = useState({
    step: 1,
    group_category: {
      id: null,
      name: null,
    },
    group_category_sub: {
      id: null,
      name: null,
    },
  })
  const [options, setOptions] = useState({
    groupsCategories: [],
  })
  //------------ Queries and Mutations ------------
  const {
    data: dataGroupsCategories,
    loading: loadingGroupsCategories,
    error: errorGroupsCategories,
  } = useQuery(GET_MIGRANTS_GROUPS_CATEGORIES)

  const [GetCategoriesSubs] = useMutation(GET_MIGRANTS_GROUPS_CATEGORIES_SUBS)

  //------------ UseEffects ------------
  useEffect(() => {
    if (!loadingGroupsCategories) {
      if (errorGroupsCategories)
        return toastSweetAlert({
          mode: 'error',
          message: errorGroupsCategories.message,
        })
      if (dataGroupsCategories?.getMigrantsGroupsCategories?.rows) {
        setOptions((prev) => ({
          ...prev,
          groupsCategories:
            dataGroupsCategories?.getMigrantsGroupsCategories?.rows,
        }))
      }
    }
  }, [dataGroupsCategories, loadingGroupsCategories, errorGroupsCategories])
  //------------ Effects for Modal Opening ------------
  useEffect(() => {
    if (modal.modalId && refModalStatus.current) {
      refModalStatus.current.click()
    }
  }, [modal.modalId])

  //------------ Functions ------------
  const handleGetCategoriesSubs = async (groupCategoryId) => {
    try {
      const { data } = await GetCategoriesSubs({
        variables: { groupCategoryId },
      })
      if (data?.getMigrantsGroupsCategoriesSubs) {
        let name = options?.groupsCategories?.find(
          (item) => item.id === groupCategoryId
        )?.name
        setProcessController({
          step: 1,
          group_category: {
            id: groupCategoryId,
            name,
          },
          group_category_sub: {
            id: null,
            name: null,
          },
        })
        return setModal({
          id: 1,
          modalId: `modal${1}`,
          size: 'extra',
          title: `Trámites de ${name}`,
          content: (
            <ModalGroupsCategoriesSubs
              refModal={refModalStatus}
              groupsCategoriesSubs={data?.getMigrantsGroupsCategoriesSubs}
              processController={processController}
              setProcessController={setProcessController}
            />
          ),
        })
      } else
        return toastSweetAlert({
          mode: 'error',
          message: 'No se encontraron subcategorías para este trámite.',
        })
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <>
      {loadingGroupsCategories ? (
        <Loader />
      ) : (
        <>
          <div className="migrants-process row">
            <div className="col-12 processes-section">
              <h5 className="title-migrates">
                {processController?.step == 2
                  ? processController?.group_category_sub?.name
                  : '¿Qué trámite deseas realizar?'}
              </h5>
              {processController?.step !== 2 ? (
                <>
                  <div className="processes-list row">
                    {options?.groupsCategories.map((groupCategory, index) => (
                      <>
                        <div className="process-item col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                          <div className="header">
                            <img
                              src={groupCategory?.image_url}
                              alt={`process-image${groupCategory?.id}`}
                            />
                          </div>
                          <div className="body">
                            <h6 className="subtitle-migrates">
                              {groupCategory?.name || 'Nombre del trámite'}
                            </h6>
                          </div>
                          <div className="footer">
                            <span
                              className="btn btn-migrates"
                              onClick={() =>
                                handleGetCategoriesSubs(groupCategory?.id)
                              }
                            >
                              VER MÁS
                            </span>
                          </div>
                        </div>
                        {index + 1 == options?.groupsCategories.length && (
                          <div className="col-12">
                            <Link to={'/#'} className="btn btn-migrates">
                              REALIZA OTROS TRÁMITES EN LA VENTANILLA DIGITAL
                            </Link>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              ) : (
                <MigrantsProcessForms processController={processController} />
              )}
            </div>
          </div>
          <span
            id={`spanModal${modal.modalId}`}
            className="invisible"
            data-toggle="modal"
            data-target={`#${modal.modalId}`}
            data-backdrop="static"
            data-keyboard="false"
            data-dismiss="modal"
            ref={refModalStatus}
          />

          <ModalContent
            idModal={modal.modalId}
            title={modal.title}
            size={modal.size}
            onClose={() => {
              setModal({
                title: '',
                content: null,
                modalId: null,
                size: 'extra',
              })
            }}
            content={modal.content}
          />
        </>
      )}
    </>
  )
}

export default MigrantsProcess
